// LINKS SWITCHER FUNCTION
(function() {
	document.addEventListener("DOMContentLoaded", function() {
		var forms = document.getElementsByClassName("link-switcher");
		var href = window.location.href;
		href = href.split('?')[0];
		var keys = [];

		//console.log(href);
		
		if(forms.length !== 0) {
			for(let i = 0; i < forms.length; i++) {
				let link = forms[i].getElementsByClassName("link-switcher__button")[0];
				link.href = href;

				for(let k = 0; k < forms[i].getElementsByTagName("input").length; k++) {
					if(forms[i].getElementsByTagName("input")[k].type === "radio") {
						let reg = new RegExp(forms[i].getElementsByTagName("input")[k].value + "$", 'i');
						keys.push(reg);
					}
				}

				//add eventlistener
				forms[i].addEventListener("click", function(event) {
					event = event || window.event;

					if(event.target.type === "radio") {
						let elem = event.target;
						
						for(let i = 0; i < keys.length; i++) {
							if(href.match(keys[i]) !== null) {
								let index = href.match(keys[i]).index;
								href = href.substring(0, index)
							}
						}

						link.href = href + elem.value;
					}
				});
			}
		}
	});
})();
